import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"

// Context
import { AuthProvider } from "./context/AuthContext"

// Static Website Components
import HomePage from "./components/static/HomePage"
import AboutPage from "./components/static/AboutPage"
import ServicesPage from "./components/static/ServicesPage"
import FAQPage from "./components/static/FAQPage"
import ContactPage from "./components/static/ContactPage"
import ScrollToTop from "./components/static/ScrollTop"


// Patient Portal Components
import PatientLogin from "./components/patient/PatientLogin"
import PatientRegister from "./components/patient/PatientRegister"
import PatientDashboard from "./components/patient/PatientDashboard"
import PatientProfile from "./components/patient/PatientProfile"
import PatientAppointments from "./components/patient/PatientAppointments"

// Admin Portal Components
import AdminLogin from "./components/admin/AdminLogin"
import AdminDashboard from "./components/admin/AdminDashboard"
import AdminPatients from "./components/admin/AdminPatients"
import AdminAppointments from "./components/admin/AdminAppointments"
import AdminDrivers from "./components/admin/AdminDrivers"
import AdminDoctors from "./components/admin/AdminDoctors"
import SuperAdminDashboard from "./components/admin/SuperAdminDashboard"
import SuperAdminLogin from "./components/admin/SuperAdminLogin"
import SuperAdminRegister from "./components/admin/SuperAdminRegister"

// Shared Components
import Navbar from "./components/shared/Navbar"
import ProtectedRoute from "./components/shared/ProtectedRoute"
import AdminRegister from "./components/admin/AdminRegister"

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-vh-100" style={{ background: "linear-gradient(135deg, #f8f9ff 0%, #e8f5e8 100%)" }}>
          <Navbar />

          <Routes>
            {/* Static Website Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Patient Portal Routes */}
            <Route path="/patient/login" element={<PatientLogin />} />
            <Route path="/patient/register" element={<PatientRegister />} />
            <Route 
              path="/patient/dashboard" 
              element={
                <ProtectedRoute requiredRole="patient">
                  <PatientDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/patient/profile" 
              element={
                <ProtectedRoute requiredRole="patient">
                  <PatientProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/patient/appointments" 
              element={
                <ProtectedRoute requiredRole="patient">
                  <PatientAppointments />
                </ProtectedRoute>
              } 
            />

            {/* Admin Portal Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/register" element={<AdminRegister />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/patients" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminPatients />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/appointments" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminAppointments />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/drivers" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDrivers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/doctors" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDoctors />
                </ProtectedRoute>
              } 
            />

            {/* Super Admin Routes */}
            <Route path="/admin/super-admin/login" element={<SuperAdminLogin />} />
            <Route path="/admin/super-admin/register" element={<SuperAdminRegister />} />
            <Route 
              path="/admin/super-admin" 
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <SuperAdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}
